import Tithely from './Tithely';

export default Tithely;
